<ng-container *ngrxLet="authDialogStep$ | async as authDialogStep">
  <div [ngSwitch]="authDialogStep" class="gb-auth-dialog-container">
    <gb-login-or-register *ngSwitchCase="AuthDialogStep.Initial" (register)="onRegister()" (login)="onLogin()">
    </gb-login-or-register>

    <gb-register-dialog *ngSwitchCase="AuthDialogStep.Register" [registerExtras]="data"> </gb-register-dialog>

    <gb-auth-dialog-login *ngSwitchCase="AuthDialogStep.Login"> </gb-auth-dialog-login>
  </div>
</ng-container>
